var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",class:{
        'header--mobile': _vm.isMobile,
    }},_vm._l((_vm.items),function(step,i){return _c('div',{key:step.id,staticClass:"step",class:_vm.$route.meta.step === step.id ? 'active' : null},[_c('span',{staticClass:"step-number"},[_vm._v(_vm._s(i + 1))]),(!_vm.isMobile)?_c('span',[_vm._v(" "+_vm._s(step.label)+" ")]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }